export default "__VITE_ASSET__Cv$$GpKx__"